import { useState } from 'react';

import { Box, Theme, Chip } from '@mui/material';
import { styled } from '@mui/material/styles';

export interface IChipFilter {
    label: string;
    type: string;
}

export interface ChipFilterProps {
    chipTypes: IChipFilter[];
    onClick: (chipType: string) => void;
}

const ListItem = styled('li')(({ theme }: { theme: Theme }) => ({
    margin: theme.spacing(0.5),
}));

const ChipFilter = ({ chipTypes, onClick }: ChipFilterProps) => {
    const [selectedChip, setSelectedChip] = useState<string>(chipTypes[0].type);

    const handleClick = (type: string) => () => {
        if (type !== selectedChip) {
            setSelectedChip(type);
            onClick(type);
        }
    };

    return (
        <Box
            component="ul"
            data-testid="chipFilter"
            sx={{
                pl: 0,
                display: 'flex',
                justifyContent: 'center',
                flexWrap: 'wrap',
                listStyle: 'none',
                m: 0,
            }}>
            {chipTypes.map(({ label, type }) => (
                <ListItem key={type} sx={{ my: 0 }}>
                    <Chip
                        data-testid={
                            type === selectedChip
                                ? 'chipFilter.selectedChip'
                                : null
                        }
                        label={label}
                        onClick={handleClick(type)}
                        sx={(theme) => ({
                            px: 1,
                            height: theme.spacing(4.75),
                            borderRadius: 4.5,
                            '& .MuiChip-label': {
                                fontSize: theme.typography.fontSize,
                            },
                            ...(type === selectedChip
                                ? {
                                      color: 'primary.contrastText',
                                      bgcolor: 'primary.main',
                                      '&:hover': {
                                          bgcolor: 'primary.dark',
                                      },
                                  }
                                : {
                                      bgcolor: 'background.paper',
                                      color: theme.palette.text.primary,
                                      '&:hover': {
                                          color: 'primary.dark',
                                          bgcolor: 'grey.100',
                                      },
                                  }),
                        })}
                    />
                </ListItem>
            ))}
        </Box>
    );
};

export default ChipFilter;
